/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RebuildCoverageRequest
 */
export interface RebuildCoverageRequest {
    /**
     * 
     * @type {string}
     * @memberof RebuildCoverageRequest
     */
    reason: string;
}

/**
 * Check if a given object implements the RebuildCoverageRequest interface.
 */
export function instanceOfRebuildCoverageRequest(value: object): value is RebuildCoverageRequest {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function RebuildCoverageRequestFromJSON(json: any): RebuildCoverageRequest {
    return RebuildCoverageRequestFromJSONTyped(json, false);
}

export function RebuildCoverageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RebuildCoverageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
    };
}

export function RebuildCoverageRequestToJSON(json: any): RebuildCoverageRequest {
    return RebuildCoverageRequestToJSONTyped(json, false);
}

export function RebuildCoverageRequestToJSONTyped(value?: RebuildCoverageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
    };
}

